<template>
    <div style="width:100%;">
        <Loading :value="loading" ></Loading>
        <span class="title" mt-2>Détail professionnel</span>
        <v-divider class="mb-3"></v-divider>
        <v-layout wrap style="width:100%;">

            <v-flex xs12 class="text-xs-right" v-show="typeAdmin == true" >
                <v-btn  color="primary" @click="showFormDetail = true" >
                    Créer
                    <v-icon right dark >add</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs12 class="text-xs-right">
              <v-tooltip bottom>
                  <v-btn class="elevation-3" slot="activator" @click="loadDetailProf()" dark icon flat color="primary">
                      <v-icon>cached</v-icon>
                  </v-btn>
                  actualiser la liste
              </v-tooltip>
            </v-flex>

            <v-flex xs12 >
                <data-tables :data="detailProfession" style="width:100%">
                    <el-table-column prop="etablissement" label="ETABLISSEMENT" align="left" >
                        <template slot-scope="scope" >
                            <span class="red--text body-2">{{scope.row.etablissement}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="faculte" label="FACULTE/SERVICE" align="left">
                        <template slot-scope="scope" >
                            <span class="blue--text body-2">{{scope.row.faculte}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="periode" label="PERIODE"  align="left"></el-table-column>
                    <el-table-column width="220" prop="diplome" label="DIPLOME/POSTE" align="left">
                        <template slot-scope="scope" >
                            <span class="orange--text body-2">{{scope.row.diplome}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="dateObtention" label="DATE DIPLOME/CONTRAT"  align="left"></el-table-column>
                    <el-table-column  prop="typeContrat" label="TYPE CONTRAT" align="left"></el-table-column>
                    <el-table-column label="FICHIERS" align="center" width="250" >
                        <template slot-scope="scope">
                            <v-tooltip bottom>
                                <v-avatar
                                        slot="activator"
                                        v-for="(image, imageIndex) in scope.row.imagesDetail"
                                        :key="imageIndex"
                                        @click="showDiapo(scope.row.imagesDetail,imageIndex)"
                                        :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                        :tile=true
                                        :size="50"
                                        color="grey lighten-4"
                                        class="mb-1 mr-1 elevation-3"
                                >
                                    <img :src="image" alt="avatar">
                                </v-avatar>
                                Cliquez pour agrandir
                            </v-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="ACTION" align="center" width="70"  >
                        <template slot-scope="scope">
                            <v-tooltip bottom>
                                <v-btn @click="deleteDetail(scope.row.idDetail)"  slot="activator" fab dark small color="red">
                                    <v-icon dark>remove</v-icon>
                                </v-btn>
                                Supprimer
                            </v-tooltip>
                        </template>
                    </el-table-column>
                </data-tables>
            </v-flex>
        </v-layout>
        <formDetailProf :idEmploye="idUserEmploye" :show="showFormDetail" @close="closeFormProf()" ></formDetailProf>

        <!--DIALOG ANNULER CONTRAT-->
        <v-dialog
                v-model="dialogSuppDetail"
                max-width="550"
        >
            <v-card>
                <v-card-title class="headline">

                    <el-alert
                            :title="'Voulez-vous supprimer cet enregistrement ? '"
                            type="warning"
                            :closable="false"
                            show-icon>
                    </el-alert>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="dialogSuppDetail = false"
                    >
                        Non
                    </v-btn>

                    <v-btn
                            color="red darken-1"
                            flat="flat"
                            @click="submitDeleteDetail()"
                    >
                        Oui
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <CoolLightBox
                :items="items"
                :index="index"
                @close="index = null"
        >

        </CoolLightBox>
    </div>
</template>

<script>
    import formDetailProf from "@/components/resourceHumaine/form_detail_prof";
    import Loading from '@/components/Loading';
    export default {
        components: {formDetailProf,Loading},
        props:{
            idUserEmploye: {
                type: Number,
                default: null
            },
            show: {
                type: Boolean,
                default: false
            },
            typeAdmin: {
                type: Boolean,
                default: true,
            }
        },
        name: "detailProfessionnel",
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                loading: false,

                detailProfession: [],
                dialogSuppDetail: false,
                idDetail: null,
                showFormDetail: false,
                items: [],
                index: null
            }
        },
        watch:{
            show: function(newValue, oldValue){
                if(newValue != null){
                    // if(this.detailProfession.length > 0){
                    //     return;
                    // }
                    this.loadDetailProf()
                }
            }
        },
        methods: {
            loadDetailProf(){

                this.loading = true;
                let data = {
                    idUserCreated: this.user.id
                };
                let url = this.domaine+"rh/detailProfessionnel/"+this.idUserEmploye;
                this.$http.get(url, {params: data}).then(resp =>{
                    this.loading = false;
                    this.detailProfession = resp.body.detailProfs
                }, error =>{
                    this.loading = false;
                    this.$message.error("Echec lors du chargement des détails professionnels de l'employé")
                });
            },
            deleteDetail(idDetail){
                this.idDetail = idDetail
                this.dialogSuppDetail = true;
            },
            submitDeleteDetail(){
                this.loading = true;
                let url = this.domaine+"rh/detailProf/"+this.idDetail+"/deleteDetail"

                this.$http.get(url).then(resp=>{
                    this.loading = false;
                    this.dialogSuppDetail = false;
                    this.successNotif(resp.body.message)
                    this.loadDetailProf()
                }, error=>{
                    this.loading = false;
                    this.dialogSuppDetail = false;
                    this.$message.error("Echec lors de la suppression des détails professionnels de l'employé")
                })
            },
            closeFormProf(){
                this.showFormDetail = false;
                this.loadDetailProf()
            },
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },
            showDiapo(images, ind){
                this.items = images
                this.index = ind;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/detail_professionnel.vue